import { createContext } from "react";
import usePersistState from "../hooks/usePersistState";

const AuthContext = createContext<any>({});

export const AuthProvider = ({ children }) => {
  // I replace this for a signal not in use
  const [auth, setAuth] = usePersistState({},'user');

  return (
    <AuthContext.Provider value={{ auth, setAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
 